import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useAppContext } from '@/context/context';

ReactGA.initialize('G-ETJ5PLKXHV');

const usePageTracking = () => {
  const location = useLocation();
  const { selectedNav } = useAppContext();
  useEffect(() => {
    if (location.pathname.includes('home') || location.pathname.includes('login') || selectedNav?.primary) {
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname,
        title: selectedNav?.primary
      });
    }
  }, [location, selectedNav?.primary]);
};

export default usePageTracking;
